<template>
    <div>
        <div>
            <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter flowStatistics"
                label-position="left" @submit.native.prevent>
                <el-form-item label="ICCID：">
                    <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getFlowStatisticsHandler"
                        clearable></el-input>
                </el-form-item>
                <el-form-item label="所属代理商：">
                    <el-select v-model="searchForm.agentId" clearable filterable>
                        <el-option v-for="item in agentListOption" :key="item.id" :value="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="池组名称：">
                    <el-select v-model="searchForm.poolId" clearable filterable>
                        <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应商：" prop="u">
                    <el-select v-model="searchForm.supplierId" filterable>
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
                            :label="`${item.name + ' ( ' + item.alias + ' )'}`"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="轮询状态："> 
                <el-select v-model="searchForm.state" clearable>
                    <el-option label="未轮询" value="0"></el-option>
                    <el-option label="轮询成功" value="1"></el-option>
                    <el-option label="轮询失败" value="2"></el-option>
                    <el-option label="异常不轮询" value="3"></el-option>
                </el-select>
            </el-form-item>


                <el-form-item label="轮询日期：" class="dateRange">
                    <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item class="btnArea">
                    <el-button type="primary" @click="getFlowStatisticsHandler" plain icon="el-icon-search">搜 索 查 询</el-button>
                    <el-button type="success" @click="exportInfoHandle" icon="el-icon-download">数 据 导 出</el-button>
                </el-form-item>
            </el-form>

        </div>



        <el-table :data="everyDayTbpg.tableData" border height="600">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column prop="iccid" label="卡号" align="center"></el-table-column>
            <el-table-column prop="activeName" label="激活情况" align="center"></el-table-column>
            <el-table-column prop="poolName" label="所属池组" align="center"></el-table-column>
            <el-table-column prop="agentName" label="所属代理" align="center"></el-table-column>
            <el-table-column prop="supplierName" label="供应商" align="center"></el-table-column>
            <el-table-column prop="stateName" label="最新轮询状态" align="center"></el-table-column>
            <el-table-column align="center" label="系统备注">
                <template v-slot="scope">
                    <el-tooltip :content="scope.row.remark">
                        <p style="color:crimson"> {{ scope.row.remark }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="lunTime" label="轮询时间" align="center"></el-table-column>
            <el-table-column prop="createTime" label="导入时间" align="center"></el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="everyDayTbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="everyDayTbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="everyDayTbpg.total">
        </el-pagination>



        <!-- <el-tabs v-model="activeName" type="card" >            

            <el-tab-pane label="每月流量详情" name="everyMonthTable">
                <el-table :data="tbpg.tableData" border height="600">
                    <el-table-column type="index" label="序号"></el-table-column>
                    <el-table-column label="ICCID">
                        <template slot-scope="scope">
                            <a href="javascript:void(0)" @click="toEveryDayTable(scope.row.iccid)">{{ scope.row.iccid }}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplierName" label="供应商"></el-table-column>
                    <el-table-column prop="createTime" label="月 份"></el-table-column>
                    <el-table-column prop="dataAmount" label="使用流量（G）">
                        <template slot-scope="scope">
                            {{ fluxMtoG(scope.row.dataAmount) }}
                        </template>
                    </el-table-column>
                </el-table> 
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="tbpg.currentPage"
                    :page-sizes="[15, 50, 100, 500]"
                    :page-size="tbpg.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tbpg.total">
                </el-pagination> 
            </el-tab-pane>

            <el-tab-pane label="每日流量详情" name="everyDayTable">
                <el-table :data="everyDayTbpg.tableData" border height="600">
                    <el-table-column type="index" label="序号"></el-table-column>
                    <el-table-column label="ICCID">
                        <template slot-scope="scope">
                            <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplierName" label="供应商"></el-table-column>
                    <el-table-column prop="createTime" label="日 期"></el-table-column>
                    <el-table-column prop="dataAmount" label="使用流量（G）">
                        <template slot-scope="scope">
                            {{ fluxMtoG(scope.row.dataAmount) }}
                        </template>
                    </el-table-column>
                </el-table> 
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="everyDayTbpg.currentPage"
                    :page-sizes="[15, 50, 100, 500]"
                    :page-size="everyDayTbpg.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="everyDayTbpg.total">
                </el-pagination> 
            </el-tab-pane>


           <el-tab-pane label="柱形图" name="statisticsBar">
                <div id='everyDayAmount'>
                    <div id="fluxStatistics_everyDayAmount" 
                        style="width: 100%;height: 600px;"
                    >
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs> -->

    </div>
</template>
<script>
import { flowStatistics, flowEveryDayDetail, flowEveryMonthDetail, flowStatisticsExport } from '@/api/csm.js'
import common from '@/utils/common.js'
var echarts = require('echarts');      // 引入 ECharts 主模块
export default {
    data() {
        return {
            agentListOption: [],
            searchForm: {
                agentName: '',
                iccid: null,
                remark: '',
                time: null,
                into_no: null,
                supplierCode: '',
                basePkgGroup: '',
                dataAmount: null,
            },
            pkgGroup: [],
            //每月流量详情表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            //每日流量详情表
            everyDayTbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            thisMonth: '',
            activeName: 'everyMonthTable',
            everyDayAmountData: [],
            branchSupplierOption: [],
            monthFlow: [{
                createTime: '',
                dataAmount: ''
            }],

            stopMessage: '0',
            moreThanNumber: '0',
            sumTotoalData: '0',
            totalOutData: '0'

        }
    },
    methods: {
        getFlowStatisticsHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            if (data.dataAmount) {
                data.dataAmount = data.dataAmount * 1024;
            }
            common.sysRequest('pool/select/sim/all/list', data, 'post').then(res => {
                common.listCallback(this, res, 'everyDayTbpg');
            })

        },

        formatDataAmount() {
            this.searchForm.dataAmount = this.searchForm.dataAmount.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },

        //获取每日流量数据
        getFlowEveryDayHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            if (data.dataAmount) {
                data.dataAmount = data.dataAmount * 1024;
            }
            data.iccid = this.currentIccic;
            flowEveryDayDetail(data).then(res => {
                common.listCallback(this, res, 'everyDayTbpg');
                this.activeName = 'everyDayTable';
            })
        },

        goToDetailPage(row) {
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },

        exportInfoHandle() {//导出excel文件
            this.$confirm("确定要导出吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.deleteSpaceKey(this.searchForm);
                let param = this.searchForm;
                common.sysRequest('export/allPoolSim', param, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(err => console.error(err));
            }).catch(() => { });
        },


        drawFlowStatisticsChart(elementId, everyDayAmountData) {
            let dataAxis = [];
            let data = [];
            let yMax = 500;
            let dataShadow = [];
            let myChart = echarts.init(document.getElementById(elementId));



            for (let i = 0; i < everyDayAmountData.length; i++) {
                dataAxis.push(everyDayAmountData[i].createTime);
                data.push(everyDayAmountData[i].dataAmount);
            }

            yMax = Math.max(...data);

            for (let i = 0; i < data.length; i++) {
                dataShadow.push(yMax);
            }


            let option = {
                title: {
                    text: '每日流量统计',
                },
                xAxis: {
                    data: dataAxis,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    z: 10
                },
                yAxis: {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999'
                        }
                    }
                },
                dataZoom: [
                    {
                        type: 'inside'
                    }
                ],
                series: [
                    { // For shadow
                        type: 'bar',
                        itemStyle: {
                            normal: { color: 'rgba(0,0,0,0.05)' }
                        },
                        barGap: '-100%',
                        barCategoryGap: '40%',
                        data: dataShadow,
                        animation: false,
                    },
                    {
                        type: 'bar',
                        label: {
                            normal: {
                                show: true,
                                position: 'insideTop'
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#83bff6' },
                                        { offset: 0.5, color: '#188df0' },
                                        { offset: 1, color: '#188df0' }
                                    ]
                                )
                            },
                            emphasis: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#2378f7' },
                                        { offset: 0.7, color: '#2378f7' },
                                        { offset: 1, color: '#83bff6' }
                                    ]
                                )
                            }
                        },
                        data: data
                    }
                ]
            };

            myChart.setOption(option);
        },

        handleSizeChange(val) {
            this.tbpg.pageSize = val;
            this.getFlowStatisticsHandler();
        },
        handleCurrentChange(val) {
            this.tbpg.currentPage = val
            this.getFlowStatisticsHandler();
        },
    },
    created() {
        common.getAgentListOptionCom(this, 'agentListOption');
        common.sysRequest('pool/select/pool/user/list', {}, 'post').then(res => {
            this.pkgGroup = res.data.data;
        })
        this.thisMonth = this.dateFormat("yyyy-MM", new Date());
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
    },

    mounted() {
        this.getFlowStatisticsHandler();
    },

    updated: function () {

    },

    watch: {

    }
}
</script>

<style>
.flowStatistics .el-input-group__prepend,
.flowStatistics .el-input-group__append {
    background-color: #f5f5f5;
}

.flowStatistics .el-form-item__content {
    width: 250px;
}
</style>

<style lang="less" scoped>
.forTbFilter {
    display: inline-block;

    .btnArea {
        display: inline-block;
        margin-left: 30px;

    }
}

.stopMessage {
    font-size: 18px;
    margin: 0 0 10px 0;

    span {
        color: #ea2929;
        margin-right: 60px;

    }
}
</style>